/**
 * Capture channels a user may filter attendances by.
 *
 * `portal_olx` and `portal_grupo_olx` are deliberately absent: the OLX
 * portal integrations are not functional yet, so offering them as filters
 * would only ever return an empty board. Their i18n labels stay in the
 * locale files, so attendances already captured with those channels keep
 * rendering — only the ability to *select* them is gone. Re-add the ids
 * here once the integrations go live.
 */
export const SELECTABLE_ORIGIN_CHANNELS = [
  'site',
  'meta',
  'referral',
  'manual',
] as const;

export type SelectableOriginChannel = (typeof SELECTABLE_ORIGIN_CHANNELS)[number];
